"use client";

import { useAuth } from '@/contexts/AuthContext';
import TermsAndConditionsModal from './ui/termsAndConditionsModal';

export default function GlobalTermsModal() {
  const { showTermsModal, closeTermsModal } = useAuth();

  return (
    <TermsAndConditionsModal
      isOpen={showTermsModal}
      onClose={closeTermsModal}
    />
  );
}
